import { ApolloClient, InMemoryCache, HttpLink } from '@apollo/client';
import { setContext } from '@apollo/client/link/context';
import { onError } from '@apollo/client/link/error';

const httpLink = new HttpLink({
  uri: import.meta.env.VITE_API_URL,
});

const authLink = setContext((_, { headers }) => {
  const token = localStorage.getItem('token');

  return {
    headers: {
      ...headers,
      ...(token && { authorization: token }),
    },
  };
});

const errorLink = onError(({ graphQLErrors }) => {
  if (graphQLErrors) {
    graphQLErrors.forEach(({ message }) => {
      if (
        localStorage.getItem('token') &&
        message === 'You must be signed in'
      ) {
        localStorage.removeItem('token');

        if (location.pathname !== '/') {
          document.location.href = '/';
        }
      }
    });
  }
});

export default new ApolloClient({
  link: authLink.concat(errorLink).concat(httpLink),
  cache: new InMemoryCache({
    typePolicies: {
      Space: {
        fields: {
          topics: {
            keyArgs: ['archived', 'assigneeId', 'authorId', 'state', 'tagId'],
          },
        },
      },
      Topic: {
        fields: {
          state: {
            read(state) {
              return (
                state?.charAt(0).toUpperCase() + state?.slice(1).toLowerCase()
              );
            },
          },
        },
      },
      SpaceMember: {
        keyFields: ['spaceId', 'user', ['id']],
        fields: {
          role: {
            read(role) {
              return role.toLowerCase();
            },
          },
        },
      },
    },
  }),
  connectToDevTools: import.meta.env.DEV && true,
});
